import { css } from '@emotion/css';

const getFontFamilyName = (num) => {
  switch (num) {
    case '1':
      return 'Arial, Helvetica, sans-serif';
    case '2':
      return 'Times New Roman, Times, serif';
    case '3':
      return 'Roboto, sans-serif';
    case '4':
      return 'Open Sans, sans-serif';
    default:
      return 'inherit';
  }
};

const getPreviewStyle = (settings) => css`
  background-color: ${settings['iframe/20/14/20']};
  max-width: ${settings['iframe/20/14/24'] ? `${settings['iframe/20/14/23']}px` : 'unset'};

  .form-group {
    font-family: ${getFontFamilyName(settings['iframe/20/13/18'])};
    color: ${settings['iframe/20/14/21']};
    max-width: ${settings['iframe/20/15/24'] ? `${settings['iframe/20/15/23']}px` : 'unset'};

    label {
      font-size: ${settings['iframe/20/13/19']}px;
    }

    .form-text {
      color: ${settings['iframe/20/14/22']};
    }

    .form-control,
    select.form-control {
      font-size: ${settings['iframe/20/13/19']}px;
      background-color: ${settings['iframe/20/15/20']};
      color: ${settings['iframe/20/15/21']};
      height: ${settings['iframe/20/15/25']}px;
    }
  }

  .btn.btn-submit {
    font-family: ${getFontFamilyName(settings['iframe/20/13/18'])};
    font-size: ${settings['iframe/20/16/19']}px;
    color: ${settings['iframe/20/16/21']};
    background-color: ${settings['iframe/20/16/20']};
    height: ${settings['iframe/20/16/25']}px;
    border-radius: ${settings['iframe/20/16/27']}px;
    max-width: ${settings['iframe/20/16/24'] ? `${settings['iframe/20/16/23']}px` : 'unset'};
  }
  .checkbox.agreement {
    font-family: ${getFontFamilyName(settings['iframe/20/13/18'])};
    color: ${settings['iframe/20/14/22']};
  }
`;

export { getPreviewStyle };
